
let currentUrl = window.location.pathname;
function slideUpFadeOut(element, duration = 500) {
  // Set initial styles for the transition
  element.style.height = `${element.offsetHeight}px`;
  element.style.opacity = '1';
  element.style.transitionProperty = 'height, margin, padding, opacity';
  element.style.transitionDuration = `${duration}ms`;

  // Trigger the transition
  requestAnimationFrame(() => {
    element.style.overflow = 'hidden';
    element.style.height = '0';
    element.style.paddingTop = '0';
    element.style.paddingBottom = '0';
    element.style.marginTop = '0';
    element.style.marginBottom = '0';
    element.style.opacity = '0';
  });

  // Remove styles and set display to none after animation
  setTimeout(() => {
    element.style.display = 'none';
    element.style.removeProperty('height');
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');
    element.style.removeProperty('overflow');
    element.style.removeProperty('opacity');
    element.style.removeProperty('transition-duration');
    element.style.removeProperty('transition-property');
  }, duration);
}

let slug = currentUrl.includes('/en') ? '/en' : '';

function openCartDrawer() {
    document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
    document.querySelector('html').classList.add('o-hidden');
  }
  
  function closeCartDrawer() {
    document
      .querySelector(".cart-drawer")
      .classList.remove("cart-drawer--active");
      document.querySelector('html').classList.remove('o-hidden');
  }
  
  function updateCartItemCounts(count) {
    document.querySelectorAll(".cart-count").forEach((el) => {
      el.textContent = count;
    });
  }
  
  async function updateCartDrawer() {
    const res = await fetch(`${slug}/?section_id=cart-drawer`);
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;
  
    const newBox = html.querySelector(".cart-drawer").innerHTML;
  
    document.querySelector(".cart-drawer").innerHTML = newBox;
  
    addCartDrawerListeners();
  }
  
  function addCartDrawerListeners() {
    // Update quantities
    document
      .querySelectorAll(".cart-drawer-quantity-selector button")
      .forEach((button) => {
        button.addEventListener("click", async () => {
          // Get line item key
          const rootItem =
            button.closest('.cart-drawer-item');
          const key = rootItem.getAttribute("data-line-item-key");
  
          // Get new quantity
          const currentQuantity = Number(
            button.parentElement.querySelector("input").value
          );
          const isUp = button.classList.contains(
            "cart-drawer-quantity-selector-plus"
          );
          const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
  
          // Ajax update\
          const res = await fetch("/cart/update.js", {
            method: "post",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates: { [key]: newQuantity } }),
          });
          const cart = await res.json();
  
          updateCartItemCounts(cart.item_count);
          if(newQuantity === 0){
            slideUpFadeOut(rootItem, 500)
            // Update cart
            setTimeout(() => {
              updateCartDrawer();
            },400)
          } else {
            updateCartDrawer();
          }
          // Update cart
          
        });
      });

      document.querySelectorAll(".drawer-item-remove")
      .forEach((button) => {
        button.addEventListener("click", async () => {
          // Get line item key
          const rootItem =
            button.closest('.cart-drawer-item');
          const key = rootItem.getAttribute("data-line-item-key");
  
          // Get new quantity
          
  
          // Ajax update\
          const res = await fetch("/cart/update.js", {
            method: "post",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates: { [key]: 0 } }),
          });
          const cart = await res.json();
  
          updateCartItemCounts(cart.item_count);
          slideUpFadeOut(rootItem, 500)
          // Update cart
          setTimeout(() => {
            updateCartDrawer();
          },400)
        });
      });

      
  
    document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
      e.stopPropagation();
    });
  
    document
      .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
      .forEach((el) => {
        el.addEventListener("click", () => {
          console.log("closing drawer");
          closeCartDrawer();
        });
      });
  }
  
  addCartDrawerListeners();
  
  document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
    if(form.closest('product-form')) return;
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
  
      // Submit form with ajax
      await fetch(`${routes.cart_add_url}`, {
        ...fetchConfig('javascript'),
        body: new FormData(form),
      });
  
      // Get cart count
      const res = await fetch("/cart.js");
      const cart = await res.json();
      updateCartItemCounts(cart.item_count);
  
      // Update cart
      await updateCartDrawer();
  
      // Open cart drawer
      openCartDrawer();
    });
  });
  
  document.querySelectorAll('.header__icon--cart').forEach((a) => {
    a.addEventListener("click", (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  });